
let util = {}
util.isMobile = (value) => {
    let length = value.length;
    let mobile = /^(13[0-9]|15[012356789]|16[6]|17[0135678]|18[0-9]|19[89])[0-9]{8}$/;
    return  mobile.test(value)
} 


util.isIdCard = (value) => {
	let idCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
	return idCard.test(value)
}

util.isMail = (value) => {
	let mailReg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
	return mailReg.test(value)
}




util.dealImg = function (param) {
	if (param) {
		if(param.indexOf(',') != -1){
			param.split(',').forEach(ele => {
				if(ele){
					param = ele;
				}
			})
		};
		if(param.indexOf('http') != -1) {
			return param;
		};
		if(param.indexOf('https') != -1) {
			return param;
		};
		if(param.indexOf('upload') != -1) {
			return 'http://date.risingch.com' + param;
		} else {
			return 'http://date.risingch.com/upload' + param;
		};
    }	
}

util.os = () => {
	const u = navigator.userAgent, app = navigator.appVersion;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
	const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	const isIOSApp = u.indexOf('ios') > -1 ; //iosapp
	const isAndroidApp = u.indexOf('android') > -1 ; //androidapp

    if (isAndroid) {
	   //这个是安卓操作系统
	   return  isAndroidApp ? 'androidApp' : 'android'
    }
    if (isIOS) {
　　　　//这个是ios操作系统
		return isIOSApp ? 'iosApp' : 'ios'
	}
}

util.Deserialize = function () { //反序列化
	var utldata=location.search;
	var paramsString = utldata.replace("?", "");
	var paramsTempObj = paramsString.split("&");
	var paramsObj = {};

	for (var i = 0; i < paramsTempObj.length; i++) {
		paramsObj[paramsTempObj[i].split("=")[0]] = paramsTempObj[i].split("=")[1]
	}
	return paramsObj;
}

/**
* 数据 按照 拼音首字母 排序 并分组
* 
* @param {Json} data ; 需要 排序的 数据
* @param {String} field ；必须；排序所依据的 字段 名
* 
* @return {Json} ; 例如：{A:[{},{}],B:[{},{}],C:[{}],#:[]}
*/
util.data_letter_sort  = (data, field) => {
   const letter_reg = /^[A-Z]$/;
   const list = new Array();
   for (let i = 0; i < data.length; i++) {
	   // 添加 # 分组，用来 存放 首字母不能 转为 大写英文的 数据
	   list['#'] = new Array();
	   // 首字母 转 大写英文
	   let letter = (data[i][field]).substr(0, 1).toUpperCase();
	   // 是否 大写 英文 字母
	   if (!letter_reg.test(letter)) {
		   letter = '#';
	   }
	   // 创建 字母 分组
	   if (!(letter in list)) {
		   list[letter] = new Array();
	   }
	   // 字母 分组 添加 数据
	   list[letter].push(data[i]);
   }
   // 转换 格式 进行 排序；
   let resault = new Array();
   for (let key in list) {
	   resault.push({
		   letter: key,
		   list: list[key]
	   });
   }
   resault.sort(function (x, y) {
	   return x.letter.charCodeAt(0) - y.letter.charCodeAt(0);
   });
   // # 号分组 放最后
   let last_arr = resault[0];
   resault.splice(0, 1);
   resault.push(last_arr);

   // 转换 数据 格式
   let json_sort = {}
   for (let i = 0; i < resault.length; i++) {
	   json_sort[resault[i].letter] = resault[i].list;
   }

   return json_sort;
}


/***
 * 判断浏览器打开
 * @returns 1、微信内置浏览器，2、qq内置浏览器
 */
util.judgeBrowser = () => {
	var ua = window.navigator.userAgent.toLowerCase();
	// console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return window.__wxjs_environment === 'miniprogram' ? 3 :  1;
	} else if(ua.indexOf(' qq')>-1 && ua.indexOf('mqqbrowser') <0){
		return 2;
	}
}


util.formatMsgTime = (timespan) => {

	let dateTime = new Date(timespan.replace(/-/g,'/'));
  
	let year = dateTime.getFullYear();
	let month = util.addZero(dateTime.getMonth() + 1);
	let day = util.addZero(dateTime.getDate());
	let hour = util.addZero(dateTime.getHours());
	let minute = util.addZero(dateTime.getMinutes());
	let second = util.addZero(dateTime.getSeconds());
	let now = new Date();
	let now_new = Date.parse(now.toDateString());  //typescript转换写法
  
	let milliseconds = 0;
	let timeSpanStr;
	milliseconds = now_new - timespan;
  
	if (milliseconds <= 1000 * 60 * 1) {
	  timeSpanStr = '刚刚';
	}
	else if (1000 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60) {
	  timeSpanStr = Math.round((milliseconds / (1000 * 60))) + '分钟前';
	}
	else if (1000 * 60 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24) {
	  timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + '小时前';
	}
	else if (1000 * 60 * 60 * 24 < milliseconds && milliseconds <= 1000 * 60 * 60 * 24 * 15) {
	  timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60 * 24)) + '天前';
	}
	else if (milliseconds > 1000 * 60 * 60 * 24 * 15 && year == now.getFullYear()) {
	  timeSpanStr = month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
	} else {
	  timeSpanStr = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
	}
	return timeSpanStr;
};

util.addZero = val => parseInt(val) >= 10 ? val : `0${val}`

util.time = new Date().getTime()

util.dominame = `${window.location.protocol}//${ window.location.host }/share/#`

export default util